import React from 'react';
import store from './store';
import App from './router';
import { Provider as ReduxProvider } from 'react-redux';
import { ErrorBoundary } from '@sentry/react';
import { createRoot } from "react-dom/client"
import './bootstrap';
import './sentry';

const root = createRoot(document.getElementById('app'));

root.render(
  <ErrorBoundary>
    <ReduxProvider store={store}>
      <App />
    </ReduxProvider>
  </ErrorBoundary>
);